import React, { FC } from 'react';
import { useExperiments } from '@wix/wix-experiments-react';
import { CloseButton, Loader, Modal } from '../..';
import { IOuter } from './HelpModal.types';
import styles from './HelpModal.scss';
import { useBoolean } from '../../../../utils/hooks/useBoolean';
import { ExperimentSpec } from '../../../../constants/ExperimentSpec';
import { useHelpWidget } from '../useHelpWidget';

export const HelpModal: FC<IOuter> = ({ article, onClose }) => {
  const { value: isLoaded, setTrue: setLoadedTrue } = useBoolean(false);
  const { experiments } = useExperiments();
  const isNewHelpWidgetEnabled = experiments.enabled(ExperimentSpec.UseNewHelpWidget);
  const { openHelpWidgetArticle } = useHelpWidget();

  if (!article) {
    return null;
  }

  if (isNewHelpWidgetEnabled && window.WixSupportChatSDK) {
    openHelpWidgetArticle(article);
    onClose();
    return null;
  }

  return (
    <Modal zIndex={7500} isOpen onRequestClose={onClose} contentLabel="help-modal" shouldCloseOnOverlayClick>
      <div className={styles.content}>
        <CloseButton className={styles.closeButton} skin="lightFilled" size="medium" onClick={onClose} />

        <iframe src={article} className={styles.iframe} onLoad={setLoadedTrue} />

        {!isLoaded && (
          <div className={styles.loaderWrapper}>
            <Loader />
          </div>
        )}
      </div>
    </Modal>
  );
};
